import React, { Component } from 'react';
import imgBg from "../assets/img/cctv.jpg";
import carouselIm from "../assets/img/carousel-2.jpg";

export class About extends Component {
    static displayName = About.name;

  render() {
    return (
        <div>

            {/*aboutus navbar starts here*/}
            <div class="container-fluid position-relative p-0">
                <div class="container-fluid bg-primary py-5 bg-header">
                    <div class="row py-5">
                        <div class="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                            <h3 class="text-capitalize text-white animated zoomIn">about us</h3>
                            <a class="h5 text-capitalize text-white">home</a>
                            <i class="bi bi-chevron-right text-white px-2"></i>
                            <a class="h5 text-capitalize text-white">about</a>
                        </div>
                    </div>
                </div>
            </div>
            {/*aboutus navbar ends here*/}

            {/*aboutus section starts here*/}
            <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div class="container py-5">
                    <div class="row g-5">
                        <div class="col-lg-6">
                            <div class="section-title position-relative pb-3 mb-5">
                                <h5 class="fw-bold text-primary text-uppercase">our story</h5>
                                <h1 class="mb-0">Best IT Solutions</h1>
                            </div>
                            <p class="mb-4">
                                Jewstechs was founded to deliver innovative and reliable ICT infrastructure solutions
                                that empower businesses and organizations. We specialize in computer networking, IT
                                infrastructure management, virtualization, enterprise storage, backup and replication,
                                and ICT consultation. Our goal is to help organizations build secure, scalable, and
                                high-performing technology environments that support business growth and operational excellence.
                            </p>

                            <p class="mb-4">
                                We are committed to enhancing security and business continuity through advanced CCTV
                                surveillance, access control, and biometric systems. Our team designs, deploys, and
                                maintains dependable ICT infrastructure while providing proactive support and expert
                                consultation to ensure maximum system availability, data protection, and long-term reliability.
                            </p>
                            <div class="row g-0 mb-3">
                                <div class="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                                    <h5 class="mb-3 text-capitalize">our objectives</h5>
                                    <p class="mb-3"> To secure sensitive areas </p>
                                    <p class="mb-3"> To improve efficiency of tools </p>
                                    <p class="mb-3">To offer core infrastructure elements for organizations </p>
                                </div>
                                <div class="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                                    <h5 class="mb-3 text-capitalize">our core values</h5>
                                    <p class="mb-2 text-capitalize"><i class="bi bi-shield-check text-primary me-3"></i>accountability</p>
                                    <p class="mb-2 text-capitalize"><i class="bi bi-award text-primary me-3"></i>professionalism</p>
                                    <p class="mb-2 text-capitalize"><i class="bi bi-globe2 text-primary me-3"></i>diversity & inclusion</p>
                                    <p class="mb-2 text-capitalize"><i class="bi bi-people text-primary me-3"></i>teamwork & collaboration</p>
                                    <p class="mb-2 text-capitalize"><i class="bi bi-patch-check-fill text-primary me-3"></i>commitment & responsibility</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div class="position-relative h-100">
                                <img class="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src={imgBg}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*aboutus section ends here*/}


      </div>
    );
  }
}
